import { httpService } from "./http-service"
import { refreshToken } from "utils/external-login-helper"

function handleHttpError(error) {
  const serverErrorCode = [400, 403, 404, 422]
  const genericErrorMessage = "Failed to process your request."

  if (error.response && error.response.data) {
    let responseData = null
    if (serverErrorCode.includes(error.response.status)) {
      responseData = error.response.data.error.message
    } else if (error.response.status === 401) {
      responseData = "Unauthorized"
    } else if (error.response.data.error) {
      responseData = error.response.data.error.message
    } else {
      responseData = error.response.data
    }

    return responseData || genericErrorMessage
  }

  return genericErrorMessage
}

const forceAuthentication = () => {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.set("unauthorized", "true")
  window.location.search = urlParams
}

const makeHttpRequest = async (apiCall, attempts = 1) => {
  try {
    const data = await apiCall()
    if (data === 401 || data === 403) {
      if (attempts === 1) {
        await refreshToken()
        return await makeHttpRequest(apiCall, attempts + 1)
      } else {
        forceAuthentication()
      }
    }

    if (data?.error?.message) return Promise.resolve(data?.error?.message)

    return Promise.resolve(data)
  } catch (e) {
    return Promise.reject(handleHttpError(e))
  }
}

export function getRequest(path, options = {}) {
  return makeHttpRequest(() => httpService.get(path + (options.params ? `?${new URLSearchParams(options.params).toString()}` : "")))
}

export function postRequest(path, data, options = {}) {
  return makeHttpRequest(() => httpService.post(path, data))
}

export function putRequest(path, data, options = {}) {
  return makeHttpRequest(() => httpService.put(path, data))
}

export function patchRequest(path, data, options = {}) {
  return makeHttpRequest(() => httpService.patch(path, data))
}

export function deleteRequest(path, options = {}) {
  return makeHttpRequest(() => httpService.delete(path + (options ? `?${new URLSearchParams(options).toString()}` : "")))
}
